import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileTabbtnBox from 'routes/adminMobile/components/common/AdminMobileTabbtnBox';

// 탭 버튼 카테고리
import categories from 'routes/adminMobile/commonVar/orderCategory';
import AdminMobileOrderList from '../components/AdminMobileOrderList';

// 발주 내역 테스트 데이터
import testOrderData from 'routes/adminMobile/commonVar/testOrderData';

// 상품 테스트 데이터
import testProductData from 'routes/adminMobile/commonVar/testProductData';

const AdminMobileOrder = () => {
    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    

    // 현재 선택된 카테고리를 상태로 관리
    const [selectedCategory, setSelectedCategory] = useState(categories[0].name);
    

    // 필터링된 발주 리스트를 상태로 관리
    const[filteredOrders, setFilteredOrders] = useState([]);

    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };

    // 탭 버튼을 클릭하여 카테고리 변경
    const handleTabChange = (categoryName) => {
        setSelectedCategory(categoryName);
    };

    // testOrderData와 testProductData를 조인하여 상품 정보를 추가한 데이터 생성
    const ordersWithProducts = testOrderData.map(order => {
        // 해당 주문의 상품 번호와 수량 정보
        const { productNo, productCnt } = order;
    
        // 상품 번호로부터 상품 정보 및 대표 이미지 가져오기
        const products = productNo.map(no => {
            const productIndex = testProductData.findIndex(product => product.productNo === no);
            return testProductData[productIndex];
        });
    
        // 대표 이미지와 각 상품의 이미지 경로 가져오기
        const mainProductImage = products.length > 0 ? products[0].productImg : null;
        const productImages = products.map(product => product.productImg);
        const productNames = products.map(product => product.productName);
    
        // 각 상품의 발주 개수, 발주 금액 및 이미지 경로, 상품명 계산
        const productOrderDetails = products.map((product, index) => {
            const orderQuantity = productCnt[index];
            const orderAmount = product.productSupplyPrice * orderQuantity;
            const productImage = productImages[index]; // 각 상품의 이미지 경로 추가
            const productName = productNames[index]; // 각 상품의 상품명 추가
            return { orderQuantity, orderAmount, productImage, productName };
        });
    
        // 총 발주 금액 및 총 발주 갯수 계산
        let totalOrderAmount = 0;
        let totalOrderQuantity = 0;
    
        productOrderDetails.forEach(({ orderQuantity, orderAmount }) => {
            totalOrderAmount += orderAmount;
            totalOrderQuantity += orderQuantity;
        });
    
        // 대표상품명 외 2건 문자열 생성
        const mainProduct = products[0].productName;
        const otherProducts = products.slice(1).map(product => product.productName);
        const otherProductsCount = otherProducts.length;
        const otherProductsString = otherProductsCount > 0 ? `외 ${otherProductsCount}건` : '';
    
        // 데이터에 추가
        return {
            ...order,
            products,
            mainProduct,
            otherProductsString,
            totalOrderAmount,
            totalOrderQuantity,
            mainProductImage,
            productOrderDetails
        };
    });
    //

    useEffect(() => {
        // 선택된 카테고리에 따라 발주 리스트 필터링
        let filtered = ordersWithProducts;
        if (selectedCategory !== 'all') {
            filtered = filtered.filter(order => order.orderStatus === selectedCategory);
        }
    
        // 검색어가 있으면 해당 검색어를 포함하는 발주 필터링
        if (searchKeyword) {
            filtered = filtered.filter(order => 
                order.mainProduct.toLowerCase().includes(searchKeyword.toLowerCase()) ||
                order.storeName.toLowerCase().includes(searchKeyword.toLowerCase())
            );
        }
    
        setFilteredOrders(filtered);
    }, [searchKeyword, selectedCategory]);

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>발주 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="상품명, 매장명을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 탭 버튼 기능 */}
                        <AdminMobileTabbtnBox
                            categories={categories}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={handleTabChange}
                        />
                    </FlexChild>
                    <FlexChild>
                        {/* 발주 내역 리스트 출력 */}
                        <AdminMobileOrderList orders={filteredOrders} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileOrder;